import { useEffect, useMemo, useState } from "react";
import BackArrow from "../../../components/BackArrow";
import { useLocation, useNavigate } from "react-router-dom";
import {
  checkIsValidArray,
  DateUtility,
} from "../../../helpers/commonFunction";
import { getMediaFileFromDB } from "../../../helpers/offlineAPIs";
import { AppButton, DataNotFound } from "../../../components";
import { dataMessages } from "../../../helpers/messages";
import { routes } from "../../../helpers/constants";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { reqToGetRestaurantDetailsFromIDB } from "../../../store/slice/indexedDBSlice";

const SiphoningSummary = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("before");
  const location = useLocation();
  const navigate = useNavigate();
  const {
    type,
    selectedItem,
    selectedSubItem,
    selectedLocation,
    selectedRestaurant,
  } = location?.state || {};
  const { restaurantList, govermentMarketList, isRestaurantListIDBChecked } =
    useSelector(
      (state) => ({
        restaurantList: state.indexedDBReducer?.restaurantList,
        govermentMarketList: state.indexedDBReducer?.govermentMarketList,
        isRestaurantListIDBChecked:
          state.indexedDBReducer?.isRestaurantListIDBChecked,
      }),
      shallowEqual
    );

  useEffect(() => {
    if (!isRestaurantListIDBChecked) {
      dispatch(reqToGetRestaurantDetailsFromIDB({}));
    }
  }, [restaurantList, govermentMarketList, isRestaurantListIDBChecked]);

  // CURRENT SELECTED RESTAURANT
  const currSRestaurant = useMemo(() => {
    const newRestaurantList =
      type === "COMPANY" || type === "cReports"
        ? restaurantList
        : govermentMarketList;

    if (!checkIsValidArray(newRestaurantList)) {
      return selectedRestaurant;
    }

    const sRestaurant = newRestaurantList.find(
      (item) => item.id === selectedRestaurant.id
    );
    return sRestaurant || selectedRestaurant;
  }, [restaurantList, govermentMarketList]);

  // CURRENT SELECTED ITEM
  const currSItem = useMemo(() => {
    if (!currSRestaurant || currSRestaurant?.location?.length === 0) {
      return selectedItem;
    }

    const currResItem = currSRestaurant?.location.find(
      (loc) => loc.name === selectedLocation
    );
    if (!currResItem || currResItem?.items?.length === 0) return selectedItem;

    const currResSItem = currResItem?.items.find(
      (sub) => sub.id === selectedItem.id
    );
    return currResSItem || selectedItem;
  }, [currSRestaurant]);

  // CURRENT SELECTED SUB ITEM
  const currSubItem = useMemo(() => {
    if (!currSItem || currSItem?.sub_items?.length === 0)
      return selectedSubItem;

    const currSubItem = currSItem.sub_items.find(
      (sItem) => sItem.id === selectedSubItem.id
    );

    return currSubItem || selectedSubItem;
  }, [currSItem]);

  const [newSelectedSubItem, setNewSelectedSubItem] = useState(currSubItem);
  const [currentTabData, setCurrentTabData] = useState(null);

  useEffect(() => {
    const handleUpdateInitialData = async () => {
      const newData = await Promise.all(
        currSubItem?.item_report.map(async (item) => {
          if (!item?.base64?.includes("base64")) {
            const base64 = await getMediaFileFromDB(item, "image", "base64");
            return {
              ...item,
              base64: base64,
            };
          } else {
            return item;
          }
        })
      );
      setNewSelectedSubItem({ ...currSubItem, item_report: newData });
      setCurrentTabData(newData[0]);
    };
    handleUpdateInitialData();
  }, [currSubItem?.item_report]);

  const handleTabChange = (tab) => {
    const reportData =
      newSelectedSubItem?.item_report.find(
        (x) => x.status === tab || x.status === "skip"
      ) || null;
    if (reportData) {
      setActiveTab(tab);
      setCurrentTabData(reportData);
    }
  };

  const handleAddNotes = () => {
    navigate(routes.taskSummaryNotes, {
      state: {
        ...location?.state,
        selectedItem: currSItem,
        selectedSubItem: currSubItem,
        selectedLocation: selectedLocation,
        selectedRestaurant: currSRestaurant,
        type: type,
      },
    });
  };

  return (
    <div className="tcl-raffles-makati-page tcl-summaty-page">
      <div className="tcl-raffles-makati-wrapper">
        <BackArrow
          handleClick={() =>
            navigate(routes.companyReportStages, {
              state: { ...location?.state },
            })
          }
        />
        <button className="app-btn btn btn-Vlight-green mt-0">
          {currSubItem?.name.toUpperCase()} SUMMARY
        </button>

        <div className="siphoning-tabs mb-3">
          <button
            className={`siphoning-tab ${
              activeTab === "before" ? "active" : ""
            }`}
            onClick={() => handleTabChange("before")}
          >
            BEFORE
          </button>
          <button
            className={`siphoning-tab ${
              activeTab === "processing" ? "active" : ""
            }`}
            onClick={() => handleTabChange("processing")}
          >
            IN PROCESS
          </button>
          <button
            className={`siphoning-tab ${activeTab === "after" ? "active" : ""}`}
            onClick={() => handleTabChange("after")}
          >
            AFTER
          </button>
        </div>

        {currentTabData && (currentTabData?.image || currentTabData?.base64) ? (
          <div className="tcl-take-pic-wrapper">
            <img
              src={
                currentTabData?.base64?.includes("base64")
                  ? currentTabData?.base64
                  : process.env.REACT_APP_IMAGE_URL + currentTabData?.image
              }
              alt={currentTabData.status}
            />
            <div className="tcl-take-pic-text">
              <p>{DateUtility.fullDateTime(currentTabData.record_date)}</p>
            </div>
          </div>
        ) : currentTabData?.status === "skip" ? (
          <div>
            <DataNotFound name={dataMessages.skippedSiphoning} />
          </div>
        ) : (
          <div>
            <DataNotFound />
          </div>
        )}

        {currentTabData?.status !== "skip" && (
          <div className="d-flex justify-content-center mt-3">
            <AppButton
              title={
                currSubItem?.attachments || currSubItem?.base64
                  ? "View Notes"
                  : "Add Note"
              }
              isBtnRed={true}
              onClick={() => handleAddNotes()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SiphoningSummary;
